const redirectUri =
  process.env.NODE_ENV === 'production'
    ? 'https://new.insightcore.io/assets/oauth/google/index.html'
    : 'http://localhost:3001/assets/oauth/google/index.html';

export default redirectUri;
